<template>
  <div class="Div">
    <section class="sectionContent">
      <labars-bread></labars-bread>
      <div class="details">
        <p class="title">
          {{details.video_title_cn}}
        </p>
        <div class="author">
          <span>
             {{details.send_time}}
          </span>
          <span>

            {{details.sourceTitle}}：{{details.video_source_cn}}
          </span>
        </div>
        <div class="contents">
          <!-- <video-player
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
          ></video-player> -->
          <video
            class="video"
            id="video"
            :src="details.video_url"
            controls="controls"
            preload
            :poster="details.video_img"
            @play="playClick()"
            @pause="pauseClick()"
            controlsList="nodownload"
          >
            您的浏览器不支持video标签播放器
          </video>
          <i
            :class="videoBool?'el-icon-video-play':''"
            @click="playClick()"
          ></i>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import LabarsBread from "../../layout/LabarsBread";
import { videoDetails } from "../../api/Overview";
export default {
  name: "VideoDetail",
  data() {
    return {
      videoBool: true,
      playerOptions: {
        playbackRates: [0.1, 0.5, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            // ,ogg,mp3,wav,flac,aac,ogv
            type: "video/mp4", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "" //url地址
          }
        ],
        poster: "../../../static/image/home1.png", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      },
      details: {fileList:[]}
    };
  },
  components: {
    LabarsBread
  },
  methods: {
    playClick() {
      document.getElementById("video").play();
      this.videoBool = false;
      // console.log("这是播放");
    },
    pauseClick() {
      this.videoBool = true;
      // console.log("这是暂停");
    }
  },
  created() {
    // this.playerOptions.sources[0].src='../../../static/video/ce.mp4'
    var id = this.$route.query.id;
    videoDetails({ video_id: id }).then(res => {
      // console.log(res.data);
      this.details = res.data;
    });
  },
  mounted(){
    document.getElementById("video").volume = 0.2;
    // console.log(document.getElementById("video"))
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/custom/common.scss";
.Div {
  width: 100%;
  height: 100%;
  //
  background: #f5f5f5;
}
.sectionContent {
  width: px2Rem(1300px);
  padding: 0.1px 0;
  margin: auto;
  .details {
    // height: px2Rem(1160px);
    margin-bottom: px2Rem(170px);
    background: rgba(255, 255, 255, 1);
    .title {
      padding: px2Rem(26px) px2Rem(26px) px2Rem(16px);
      font-size: px2Rem(34px);
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      text-align: center;
    }
    .author {
      padding-bottom: px2Rem(30px);
      // border-bottom: 1px solid rgba(237, 236, 236, 1);
      font-size: px2Rem(24px);
      // font-family:STXinwei;
      font-weight: 400;
      color: #999;
      text-align: center;
      span {
        display: inline-block;
        margin-right: px2Rem(15px);
        vertical-align: top;
      }
    }
    .contents {
      position: relative;
      padding: px2Rem(0px) px2Rem(30px) px2Rem(30px);
      font-size: px2Rem(24px);
      /deep/ video {
        width: 100%;
        height: px2Rem(650px);
        background: rgba(0, 0, 0, 1);
        // opacity: 0.7;
      }
      i {
        position: absolute;
        font-size: px2Rem(80px);
        color: #fff;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        cursor: pointer;
      }
    }
  }
  /deep/ .video-js {
    .vjs-icon-placeholder {
      width: 100%;
      height: 100%;
      display: block;
    }
    .vjs-big-play-button {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/index/VideoDetail.vue